// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import ChevronRightBlue from './chevron-right-blue.svg';

type Props = {
  link: string,
  imgSrc: string,
  message: string,
}

export function MapLink({ link, imgSrc, message }: Props): Node {
  return(
    <Link href={link} target="_blank">
      <Image
        src={imgSrc}
        alt="link icon"
      />
      <LinkText>
        {message}
      </LinkText>
      <img src={ChevronRightBlue} alt="Ir al sitio web"/>
    </Link>
  );
}

const LinkText = styled.p`
  flex: 0 1 auto;
  margin: 0 10px;
  line-height: 1.3;
  font-size: 14px;
  color: #666;
`;

const Link = styled.a`
  display: flex;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #f2f2f2;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;

  &:hover {
    border-color: #2397d4;
    color: #2397d4;
    ${LinkText} {
      color: #2397d4;
    }
  }
`;

const Image = styled.img`
  flex: 0 0 auto;
  height: 100%;
`;
